import { ICheckupList, IDiagnosisBlock } from 'models'

export const CHECKUP_COMMENT_MAX_LENGTH = 1000

export const isDiagnosisEntryComplete = (diagnosis: IDiagnosisBlock) =>
	Boolean(diagnosis.position) &&
	(diagnosis.sickness_id?.length ?? 0) > 0 &&
	(diagnosis.treatment_plans_id?.length ?? 0) > 0

export const getCheckupValidation = (checkupInfo: ICheckupList) => {
	const diagnoses = checkupInfo.diagnosis ?? []
	const hasCompleteDiagnosis = diagnoses.some(isDiagnosisEntryComplete)
	const hasIncompleteDiagnosis = diagnoses.some(
		diagnosis => !isDiagnosisEntryComplete(diagnosis),
	)
	const hasComment = Boolean(checkupInfo.comment?.trim())
	const disposeInvalid =
		Boolean(checkupInfo.dispose_recommended) && !hasCompleteDiagnosis
	const commentInvalid = !hasCompleteDiagnosis && !hasComment

	return {
		hasCompleteDiagnosis,
		hasIncompleteDiagnosis,
		disposeInvalid,
		commentInvalid,
		isValid: !hasIncompleteDiagnosis && !disposeInvalid && !commentInvalid,
	}
}

export const isCheckupValid = (checkupInfo: ICheckupList) =>
	getCheckupValidation(checkupInfo).isValid
